import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export type UploadStep = 'upload' | 'preview' | 'processing' | 'review';

export interface UploadStepperProps {
  currentStep: UploadStep;
  className?: string;
}

const STEPS: { key: UploadStep; label: string }[] = [
  { key: 'upload', label: 'Upload File' },
  { key: 'preview', label: 'Preview Questions' },
  { key: 'processing', label: 'Processing' },
  { key: 'review', label: 'Review' },
];

export function UploadStepper({ currentStep, className }: UploadStepperProps) {
  const currentIndex = STEPS.findIndex((s) => s.key === currentStep);

  return (
    <nav className={cn('flex items-center justify-center', className)}>
      {STEPS.map((step, index) => {
        const isCompleted = index < currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <div key={step.key} className="flex items-center">
            {/* Step indicator */}
            <div className="flex flex-col items-center gap-1.5">
              <div
                className={cn(
                  'h-8 w-8 rounded-full flex items-center justify-center text-sm font-medium border-2 transition-colors',
                  isCompleted && 'bg-primary border-primary text-primary-foreground',
                  isCurrent && 'border-primary text-primary bg-primary/10',
                  !isCompleted && !isCurrent && 'border-muted-foreground/30 text-muted-foreground'
                )}
              >
                {isCompleted ? (
                  <Check className="h-4 w-4" />
                ) : (
                  index + 1
                )}
              </div>
              <span
                className={cn(
                  'text-xs font-medium whitespace-nowrap',
                  isCurrent ? 'text-primary' : 'text-muted-foreground'
                )}
              >
                {step.label}
              </span>
            </div>

            {/* Connector line */}
            {index < STEPS.length - 1 && (
              <div
                className={cn(
                  'w-12 sm:w-20 h-0.5 mx-2 mt-[-1.25rem]',
                  index < currentIndex ? 'bg-primary' : 'bg-muted-foreground/20'
                )}
              />
            )}
          </div>
        );
      })}
    </nav>
  );
}
